import { logger } from '@fiverr-private/obs';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { currencyFormat } from '@fiverr-private/localization';
import { getContext } from '@fiverr-private/fiverr_context';
import { sessionStorage } from '@fiverr-private/futile';
import { triggerSignIn, triggerSignUp } from '@fiverr-private/identification_triggers';
import pathfinder from '@fiverr-private/pathfinder';
import { BUSINESS_TRIGGER_CTA } from '@fiverr-private/business_success_sign_modal';
import { PACKAGE_NAME, ACTIVE_CONSULTATION_PACKAGE, OVERLAY_TYPES, CONSULTATION_OVERLAY_COMPONENT } from '../constants';
import { ConsultationPackage } from '../types';
import { TriggerData } from '../components/Consultation/types';
import { SignInModalOptions } from './types';

export const getLocalizedPriceByCurrency = (currency) => (price) =>
    currencyFormat(price * currency.rate, currency.name);

/**
 * @name getTimeInSeconds
 * @param {Date} date - Native JS Date Object.
 * @return {number} - Seconds.
 */
export const getTimeInSeconds = (date) => Math.floor(date.getTime() / 1000);

/**
 * @name activeConsultationPackages
 * @param {array} packages consultationData pricing
 * @returns {array} only active packages
 */
export const activeConsultationPackages = (packages) =>
    packages.filter(({ status }) => status === ACTIVE_CONSULTATION_PACKAGE);

export const getConsultationPackageSummary = ({ session_minutes, price }: ConsultationPackage) =>
    `${session_minutes} min-${price}`;

/**
 *
 * @param {Error} error
 * @param {object} enrichment
 */
export const genericErrorHandler = (error, enrichment = {}) =>
    logger.error(error, {
        ...enrichment,
        package: PACKAGE_NAME,
    });

export const getTimesFormatter = () => {
    const { locale } = getContext();

    return new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
    });
};

export const redirect = (url) => {
    window.location.href = url;
};

export const signInModalSuccessHook = (overlayType: string) => {
    setConsultationOverlaySessionStorage(overlayType);
    window.location.reload();
};

const setConsultationOverlaySessionStorage = (overlayType: string) =>
    sessionStorage.set(CONSULTATION_OVERLAY_COMPONENT, overlayType);
export const getConsultationOverlaySessionStorage = () => sessionStorage.get(CONSULTATION_OVERLAY_COMPONENT);
export const removeConsultationOverlaySessionStorage = () => sessionStorage.remove(CONSULTATION_OVERLAY_COMPONENT);

interface EnrichSignInModalOptionsParams {
    isModalShown: boolean;
    sourcePage?: string;
    triggerData?: TriggerData;
}

export const enrichSignInModalOptions = ({
    isModalShown,
    sourcePage,
    triggerData = {},
}: EnrichSignInModalOptionsParams): Partial<SignInModalOptions> => {
    const {
        experience: { isBusiness },
    } = getContext();

    const overlayType = isModalShown ? OVERLAY_TYPES.DRAWER : OVERLAY_TYPES.MODAL;

    return {
        afterSigningSuccess: () => signInModalSuccessHook(overlayType),
        ...(isBusiness && {
            triggerCta: {
                type: BUSINESS_TRIGGER_CTA.PURCHASE,
                ...(sourcePage && { source: sourcePage }),
            },
            ...(triggerData.triggerId && {
                ...triggerData,
            }),
        }),
    };
};

export const triggerSignInApi = async (modalOptions: SignInModalOptions) => {
    try {
        await triggerSignIn({
            modalOptions: {
                ...modalOptions,
                triggerType: 'blocked_action',
            },
        });
    } catch {
        const loginPath = pathfinder('login');
        redirect(loginPath);
    }
};

export const triggerSignUpApi = async (modalOptions: SignInModalOptions) => {
    try {
        await triggerSignUp({
            modalOptions: {
                ...modalOptions,
                triggerType: 'blocked_action',
            },
        });
    } catch {
        const loginPath = pathfinder('join');
        redirect(loginPath);
    }
};
